export const CONFIG = {
  PARSE_SERVER: {
    P_APP_ID: typeof P_APP_ID !== "undefined" ? P_APP_ID : '',
    P_MASTER_KEY: typeof P_MASTER_KEY !== "undefined" ? P_MASTER_KEY : '',
    P_JS_KEY: typeof P_JS_KEY !== "undefined" ? P_JS_KEY : '',
    P_REST_KEY: typeof P_REST_KEY !== "undefined" ? P_REST_KEY : '',
  },
  APP_NAME: typeof APP_NAME !== "undefined" ? APP_NAME : "BIT-PAYZ",
  APP_PORT: typeof APP_PORT !== "undefined" ? APP_PORT : 1337,
  SLAVE_PORT: typeof SLAVE_PORT !== "undefined" ? SLAVE_PORT : 1448,
  DOMAIN: typeof DOMAIN !== "undefined" ? DOMAIN : "",
  USE_2FA: typeof USE_2FA !== "undefined" ? USE_2FA : true,
  LANGUAGE: typeof LANGUAGE !== "undefined" ? LANGUAGE : "english",
  VERSION: typeof VERSION !== "undefined" ? VERSION : "1.0.0",
  IS_SHOW_BANK_SWITCH: typeof IS_SHOW_BANK_SWITCH !== "undefined" ? IS_SHOW_BANK_SWITCH : false,

  PRIMARY_COLOR: typeof PRIMARY_COLOR !== "undefined" ? PRIMARY_COLOR : null,
  SECONDARY_COLOR: typeof SECONDARY_COLOR !== "undefined" ? SECONDARY_COLOR : null,
  PRIMARY_FONT_COLOR: typeof PRIMARY_FONT_COLOR !== "undefined" ? PRIMARY_FONT_COLOR : null,
  SECONDARY_FONT_COLOR: typeof SECONDARY_FONT_COLOR !== "undefined" ? SECONDARY_FONT_COLOR : null,
  LOGO_DIMENSION: typeof LOGO_DIMENSION !== "undefined" ? LOGO_DIMENSION : {},
  LOGO_PATH: typeof LOGO_PATH !== "undefined" ? LOGO_PATH : null,
  BG_PATH: typeof BG_PATH !== "undefined" ? BG_PATH : null,
  LOGO_FONT_STYLE: typeof LOGO_FONT_STYLE !== "undefined" ? LOGO_FONT_STYLE : {},
  FONT_SCRIPT: typeof FONT_SCRIPT !== "undefined" ? FONT_SCRIPT : null,

  WALLET_NAME: typeof WALLET_NAME !== "undefined" ? WALLET_NAME : "BITPAYZ",
  CAN_CLIENT_APPROVE: typeof CAN_CLIENT_APPROVE !== "undefined" ? CAN_CLIENT_APPROVE : false,
};